module.exports = __webpack_public_path__ + "static/download_on_mobile.d3730950.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/download_on_mobile.png
// module id = 1420
// module chunks = 168707334958949